export default __webpack_public_path__ + "static/media/wallet-and-coins-8717.d9415f5b.svg";